export default __webpack_public_path__ + "static/media/cube.f8056238.svg";